import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isZoom', (values, value) => {
  if (!value || value === '') return true
  return value.match(/^\d{1,2}$/) && value <= 18 && value >= 1
})
